import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import { useState, useMemo } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import useComparePrevious from '@userzoomlibraries/toolkit-react-utils/use-compare-previous';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import { T as TabsPropsContext } from './index.js';
import { I as IndicatorContext } from './index2.js';
import { T as TabViewer } from './index.styled4.js';
import { T as Tab } from './index.styled2.js';
import { T as TabIndicator } from './index.styled3.js';
import { T as TabsList } from './index.styled5.js';
import { jsx } from 'react/jsx-runtime';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Tabs$1 = function Tabs(_ref) {
  var activeTab = _ref.activeTab,
      children = _ref.children,
      className = _ref.className,
      defaultActiveTab = _ref.defaultActiveTab,
      disabled = _ref.disabled,
      manualSelection = _ref.manualSelection,
      onChange = _ref.onChange,
      vertical = _ref.vertical,
      forceActiveTabCentered = _ref.forceActiveTabCentered;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tabs = _useState2[0],
      setTabs = _useState2[1];

  var providerState = useMemo(function () {
    return {
      activeTab: activeTab,
      defaultActiveTab: defaultActiveTab,
      forceActiveTabCentered: forceActiveTabCentered,
      disabled: disabled,
      isVertical: vertical,
      manualSelection: manualSelection,
      onChange: onChange,
      setTabs: setTabs,
      tabs: tabs
    };
  }, [activeTab, defaultActiveTab, forceActiveTabCentered, disabled, manualSelection, onChange, useComparePrevious(tabs), vertical]);
  var classnames = "gz-tabs ".concat(className);

  if (vertical) {
    classnames = "".concat(classnames, " gz-tabs--vertical");
  }

  return /*#__PURE__*/jsx(TabsPropsContext.Provider, {
    value: providerState,
    children: /*#__PURE__*/jsx(IndicatorContext.Provider, {
      value: useState({}),
      children: /*#__PURE__*/jsx("div", {
        className: classnames,
        children: children
      })
    })
  });
};

Tabs$1.COMPONENT_ID = 'Gearz.Tabs';
Tabs$1.displayName = Tabs$1.COMPONENT_ID;
Tabs$1.Viewer = TabViewer;
Tabs$1.Tab = Tab;
Tabs$1.Indicator = TabIndicator;
Tabs$1.List = TabsList;
Tabs$1.propTypes = {
  activeTab: PropTypes.stringWithDescription('Id to set the state of the tab. (controlled)'),
  children: PropTypes.nodeWithDescription('Content of the tabs.'),
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  defaultActiveTab: PropTypes.stringWithDescription('Id of the initial tab selected. (uncontrolled)'),
  disabled: PropTypes.boolWithDescription('Flag to set if tabs are disabled'),
  manualSelection: PropTypes.boolWithDescription('Flag to show viewer once users activate press either Space, Enter, or a mouse click'),
  onChange: PropTypes.funcWithDescription('Callback called when the item is clicked. It will control the expanded state.'),
  vertical: PropTypes.boolWithDescription('Flag to make the tabs vertical.'),
  forceActiveTabCentered: PropTypes.boolWithDescription('Flag to force the active tab to be centered in the middle of the tab list.')
};
Tabs$1.defaultProps = {
  activeTab: undefined,
  children: null,
  className: '',
  disabled: false,
  defaultActiveTab: undefined,
  manualSelection: false,
  onChange: noop,
  vertical: false,
  forceActiveTabCentered: false
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Tabs = styled(Tabs$1).withConfig({
  componentId: "gz-tabs-1677758460838__sc-1itb364-0"
})(["overflow:hidden;&.gz-tabs--vertical{display:flex;height:100%;", "{display:block;}}&:not(.gz-tabs--vertical){display:block;width:100%;", "{display:inline-block;}}", ""], Tab, Tab, function (props) {
  return getThemeByProps({
    componentId: Tabs$1.COMPONENT_ID,
    props: props
  });
});
Tabs.displayName = Tabs$1.displayName;
Tabs.propTypes = Tabs$1.propTypes;
Tabs.defaultProps = Tabs$1.defaultProps;

export { Tabs as T };
